import { Component, OnInit } from '@angular/core';
import { QueryEditorBase } from 'src/core/models/query/query-editor-base';
import { IntegerQueryItemDto } from 'src/core/models/query/integer-query-item.dto';
import { ValidationRules } from 'src/core/models/validation/validation-rules';
import { ConfigStateService } from '@abp/ng.core';
import { ConversationFilterableFields } from 'src/core/models/conversation/conversation-filterable-fields.enum';

@Component({
  selector: 'ca-query-tree-node-number',
  templateUrl: './query-tree-node-number.component.html',
  styleUrls: ['./query-tree-node-number.component.scss'],
  standalone: false,
})
export class QueryTreeNodeNumberComponent extends QueryEditorBase implements OnInit {
  payload: IntegerQueryItemDto;
  min = 0;
  max: number = Number(this.configStateService.getSetting('Number.IntMaxValue'));
  isDecimalField: boolean = false;
  decimalFields: number[] = [];

  constructor(
    private configStateService: ConfigStateService,
    private queryField: ConversationFilterableFields,
  ) {
    super();

    this.decimalFields = [
      this.queryField.CallAnalysis_AgentInterruptionCountPerMinute,
      this.queryField.CallAnalysis_AgentHesitationCountPerMinute,
    ];
  }

  ngOnInit() {
    this.payload = this.node.categoryItem.payload as IntegerQueryItemDto;
    const validationRules = this.node.categoryItem.validationRules as ValidationRules;
    if (validationRules) {
      this.min = validationRules.min;
      this.max = validationRules.max;
    }
    this.node.validationStatus = true;

    this.isDecimalField = this.decimalFields.includes(this.payload.field);
  }

  operatorChanged() {
    this.node.isDirty = true;
  }

  valueChanged() {
    this.node.isDirty = true;
  }

  validateInput(value: number) {
    value = Number(value);
    if (value <= this.min) {
      this.payload.value = this.min;
    } else if (this.max && value > this.max) {
      this.payload.value = this.max;
    } else {
      if (!this.isDecimalField) {
        this.payload.value = Math.round(value);
      } else {
        this.payload.value = this.roundTo4DecimalsIfNeeded(value);
      }
    }
  }

  private roundTo4DecimalsIfNeeded(value: number): number {
    if ((value * 10000) % 1 !== 0) {
      return Number(value.toFixed(4));
    }
    return value;
  }
}
